import React, { useEffect } from 'react';

import { View, Text, StyleSheet } from '../react-native-components';
import { COLORS } from '../../../constants/color';

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    bottom: 10,
    left: 20,
    right: 20,
    alignItems: 'center'
  },
  toastContaienr: {
    marginBottom: 10,
    backgroundColor: COLORS.BLACK_MEDIUM,
    padding: 10,
    borderRadius: 4
  },
  toastText: {
    color: COLORS.WHITE_HIGH
  }
});

const Toast = ({ toast, hideToast }) => {
  const time = toast.time || 2000;
  useEffect(() => {
    const timer = setTimeout(() => {
      hideToast({ id: toast.id });
    }, time);

    return () => {
      clearTimeout(timer);
    };
  }, [toast, time, hideToast]);

  return (
    <View style={styles.toastContaienr}>
      <Text style={styles.toastText}>{toast.message}</Text>
    </View>
  );
};

const Toasts = ({ toasts, hideToast, isMicroFrontend }) => {
  if (toasts.length === 0) {
    return null;
  }

  return (
    <View style={[styles.container, isMicroFrontend && { bottom: 50 }]}>
      {toasts.map(toast => (
        <Toast key={toast.id} toast={toast} hideToast={hideToast} />
      ))}
    </View>
  );
};

export default Toasts;
